import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-20 sm:py-32 bg-[#F5F0E8]" data-id="element-171">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="bg-white p-8 sm:p-12 rounded-[3rem] shadow-sm border border-[#D4AF37]/20 relative overflow-hidden" data-id="element-173">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-96 h-96 bg-[#B4A7D6]/10 rounded-full blur-3xl -mt-48" data-id="element-174"></div>

          <div className="text-center relative z-10" data-id="element-175">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-[#2F4538] rounded-full mb-6 shadow-lg" data-id="element-176">
              <ShieldCheck className="w-10 h-10 text-[#D4AF37]" data-id="element-177" />
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-[#2F4538] mb-5" data-id="element-178">
              GARANTÍA INCONDICIONAL DE 7 DÍAS
            </h2>
            <p className="text-lg sm:text-xl text-[#B4A7D6] font-bold italic max-w-2xl mx-auto mb-10" data-id="element-179">
              "Probalo durante 7 días. Si no te cambia la vida, te devolvemos
              hasta el último peso."
            </p>

            <div className="border-t border-[#D4AF37]/20 pt-8 max-w-2xl mx-auto" data-id="element-180">
              <p className="font-bold text-[#2F4538] mb-3 text-lg" data-id="element-181">
                ¿Por qué hago esto?
              </p>
              <p className="text-[#1a1a1a]/80 leading-relaxed" data-id="element-182">
                Porque sé que funciona. Y porque quiero que te sientas 100%
                segura al tomar esta decisión.
              </p>
              <p className="text-[#B4A7D6] font-bold mt-4 text-lg" data-id="element-183">
                No tenés nada que perder. Y TODO por ganar.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}